import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { AutomationEvents } from './list';
import { Spacer } from 'app/layouts/generic';
import useScreenSize from 'hooks/size';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';

export const EventModule = () => {
  const { isMobile } = useScreenSize();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Triggers', path: '.' }]));
  }, []);

  return (
    <PageContentWrapper>
      {isMobile && <Spacer multiple={4} />}
      <AutomationEvents />
    </PageContentWrapper>
  );
};
